// extracted by mini-css-extract-plugin
export default {"rightbody":"right_rightbody__tO1ZI","button":"right_button__O+yzN","wrapper":"right_wrapper__Ep2YS"};